import { defineMessages } from "react-intl";

export default defineMessages({
  bookingNotFoundTitle: "Bokning hittades inte.",
  bookingNotFoundMessage: "Bokning hittades inte.",
  loadingErrorTitle: "Oväntat fel",
  loadingErrorMessage:
    "Något gick fel. Testa att ladda om sidan eller kontakta din vårdgivare.",
});
